import { Link, useSearchParams } from "react-router-dom";
import { PublicHeader } from "../components/PublicHeader";
import { StatusPanel } from "../components/StatusPanel";
import { isBackendConfigured, supabase } from "../lib/supabase";

export function LoginPage() {
  const [searchParams] = useSearchParams();
  async function login() {
    if (!supabase) return;
    const returnTo = searchParams.get("returnTo");
    if (returnTo?.startsWith("/")) sessionStorage.setItem("discord-oauth-return-to", returnTo);
    await supabase.auth.signInWithOAuth({
      provider: "discord",
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
        scopes: "identify email guilds.join",
      },
    });
  }

  return (
    <div className="public-page">
      <PublicHeader />
      <main id="main-content" className="login-shell">
        <section className="login-card">
          <span className="eyebrow">DISCORD IDENTITY</span>
          <h1>Connect the account you will keep.</h1>
          <p>We use Discord before the application so every application and invite has one stable owner.</p>
          {!isBackendConfigured && <StatusPanel title="Setup required" message="Discord login becomes active after Supabase is configured." />}
          <div className="hero-actions">
            <button className="btn primary" disabled={!isBackendConfigured} onClick={login}>CONTINUE WITH DISCORD</button>
            <Link className="btn" to="/">BACK HOME</Link>
          </div>
        </section>
      </main>
    </div>
  );
}
